import React, { useEffect } from 'react';

import { FileActionRunnerProvider } from 'components/FlowBuilder/FlowFileUpload/FileActionRunnerContext';
import FlowFileUpload from 'components/FlowBuilder/FlowFileUpload/FlowFileUpload/FlowFileUpload';
import FlowFileUploadHistory from 'components/FlowBuilder/FlowFileUpload/FlowFileUploadHistory/FlowFileUploadHistory';

import './ContextFiles.scss';

const MAIN_CLASS = 'context-files';
const CLASSES = {
  HEADER: `${MAIN_CLASS}__header`,
  TITLE: `${MAIN_CLASS}__title`,
  DESCRIPTION: `${MAIN_CLASS}__description`,
  FILE_UPLOAD_WRAPPER: `${MAIN_CLASS}__file-upload-wrapper`,
  FILE_HISTORY_WRAPPER: `${MAIN_CLASS}__file-history-wrapper`,
};

export default function ContextFiles() {
  useEffect(() => {
    document.title = 'Context files | Experience Studio @ Flybits';
  }, []);

  return (
    <div className={MAIN_CLASS}>
      <header className={CLASSES.HEADER}>
        <h1 className={CLASSES.TITLE}>Manage context files</h1>
        <p className={CLASSES.DESCRIPTION}>
          When you upload a list to become a context file, it can effect the rules in any experience that contains the
          same Attributes
        </p>
      </header>
      <FileActionRunnerProvider>
        <div className={CLASSES.FILE_UPLOAD_WRAPPER}>
          <FlowFileUpload allowedTypes={['text/csv']} showDownloadSampleFile />
        </div>
        <div className={CLASSES.FILE_HISTORY_WRAPPER}>
          <FlowFileUploadHistory scope="project" />
        </div>
      </FileActionRunnerProvider>
    </div>
  );
}
